import * as FileSaver from "file-saver"
import React from 'react'
import * as XLSX from "xlsx"
import Button from '../../../components/UI/Button/Button'
import DatePicker from '../../../components/UI/DatePicker/DatePicker'
import Input from '../../../components/UI/Input/Input'
import Search from '../../../components/UI/Search/Search'
import Select from '../../../components/UI/Select/Select'
import FetchData from '../../../shared/fetchData'
import './OnloadReports.css'

const OnloadReports = (props) => {

    const [from, setFrom] = React.useState('')
    const [to, setTo] = React.useState('')
    const [unitId, setUnitId] = React.useState('')
    const [units, setUnits] = React.useState([])
    const [rerender, setRerender] = React.useState(false)
    const [search, setSearch] = React.useState({
        courierTrackNumber: {
            elementType: 'input',
            elementConfig: {
                type: 'text',
                placeholder: 'شناسه سفارش دهنده'
            },
            validation: {
            },
            errorMessage: '',
            valid: true,
            value: ''
        }
    })
    const prmsn = window.localStorage.getItem("permission");
    const [loading, setLoading] = React.useState(false)
    const [notLoadReports, setOnloadReports] = React.useState([])

    React.useEffect(() => {
        if (!prmsn.split(",").includes("CUSTOMER_WRITE")) {
            var raw = JSON.stringify({
                "pl": 1000,
                "pn": 1,
                "version": "mtpx001"
            })
            var url = 'management/api/v1/units/getUnits'
            FetchData(raw, url).then(response => response.json())
                .then(result => {
                    if (result.status == 0) {
                        setUnits(result.units)
                    }
                })
                .catch(error => console.log(error))
        }
    }, [])

    const inputChangedHandler = (event) => {
        const srch = search
        srch['courierTrackNumber'].value = event.target.value
        setSearch(srch)
        setRerender(!rerender);
    }
    const changeUnit = selectedOption => {
        setUnitId(selectedOption)
    }
    const refresh = (event) => {
        const srch = search
        srch['courierTrackNumber'].value = ""
        setSearch(srch)
        setFrom('')
        setTo('')
        setUnitId('')
        setRerender(!rerender);
    }

    const changeFromDate = (unix, formatted) => {
        setFrom(formatted)
    }
    const changeToDate = (unix, formatted) => {
        setTo(formatted)
    }

    const exportToCSV = (event) => {
        const token = window.localStorage.getItem("token")
        var raw = JSON.stringify({
            "filter": {
                "fromDate": from != null && from != '' ? from : null,
                "toDate": to != null && to != '' ? to : null,
                "courierTrackNumber": search.courierTrackNumber.value != '' ? "%" + search.courierTrackNumber.value + "%" : null,
                "unitId": unitId != null && unitId != "" ? unitId.value : null,
            },
            "pl": "1048576",
            "pn": "1",
            "version": "mtpx001"
        })
        var url = 'management/api/v1/orders/getOnloadReserves'
        setLoading(true)
        FetchData(raw, url).then(response => response.json())
            .then(result => {
                setLoading(false)
                if (result.status == 0) {
                    let exportOrderReport = []
                    let count = 0
                    const orderReport = result.orders.map(o => {
                        count++
                        exportOrderReport.push({
                            'ردیف': count,
                            'نام لاکر': o.kiosk != null ? o.kiosk.description : '',
                            'شناسه باکس': o.locker != null ? o.locker.serial : '',
                            "تاریخ ثبت": o.registerDate,
                            "تاریخ شروع": o.startDate,
                            "تاریخ پایان": o.endDate,
                            "ساعت شروع": o.startTime,
                            "ساعت پایان": o.endTime,
                            'سفارش دهنده': o.unit != null ? o.unit.unitName : '',
                            "شناسه سفارش دهنده": o.courierTrackNumber,
                            "هزینه باکس": o.lockerAmount,
                            "مالیات": o.taxAmount,
                            "هزینه نهایی": o.finalAmount,
                        })
                    })
                    const fileType =
                        "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8";
                    const fileExtension = ".xlsx";
                    const ws = XLSX.utils.json_to_sheet(exportOrderReport);
                    const wb = { Sheets: { data: ws }, SheetNames: ["data"] };
                    const excelBuffer = XLSX.write(wb, { bookType: "xlsx", type: "array" });
                    const data = new Blob([excelBuffer], { type: fileType });
                    FileSaver.saveAs(data, 'OnloadReports' + fileExtension)
                }
            })
            .catch(error => setLoading(false))
    }

    const unitList = []
    if (units != null && units.length != 0) {
        units.map(z => {
            unitList.push({
                value: z.id,
                label: z.unitName
            })
        })
    }
    const formElementsArray = [];
    for (let key in search) {
        formElementsArray.push({
            id: key,
            config: search[key]
        });
    }
    let formInput = formElementsArray.map(formElement => {
        return (
            <Input
                key={formElement.id}
                elementType={formElement.config.elementType}
                elementConfig={formElement.config.elementConfig}
                value={formElement.config.value}
                invalid={!formElement.config.valid}
                shouldValidate={formElement.config.validation}
                placeholder={formElement.config.placeholder}
                errorMessage={formElement.config.errorMessage}
                col="3"
                changed={(event) => inputChangedHandler(event, formElement.id)} />
        );
    });
    let form = <div>
        <div className="row pl-4" dir="ltr">
        </div>
        <div className="row pl-4" dir="ltr" style={{ height: '0px' }}>
            <Button btnType="Refresh" clicked={refresh}></Button>
        </div>
        <div className="row mt-4">
            <div className="col-3 small-date-col">
                <DatePicker change={changeFromDate} value={from} placeHolder="تاریخ ثبت سفارش از" />
            </div>
            <div className="col-3 small-date-col">
                <DatePicker change={changeToDate} value={to} placeHolder="تاریخ ثبت سفارش تا" />
            </div>
            {prmsn.split(",").includes("CUSTOMER_WRITE") ? ''
                :
                <div className="col-3 p-0 small-date-col">
                    <Select
                        name="form-field-name"
                        value={unitId}
                        placeholder="سفارش دهنده"
                        options={unitList}
                        onChange={changeUnit}
                    />
                </div>
            }
            {formInput}
        </div>
        <div className="row text-left" dir="ltr">
            <div className="col-6 text-left ord-small-btns">
                <Button btnType="Search" clicked={exportToCSV}>
                    <span className="tab-color">
                        گزارشگیری
                    </span>
                </Button>
            </div>
        </div>
    </div>
    return (
        <div className="third-notLoadReports">
            <Search class="orders-search" form={form} />
        </div>
    )
}
export default OnloadReports